import React from 'react';
import { Container } from 'react-bootstrap';

function Home() {
  return (
    <Container className="container">
      <center><h1>Welcome to My Profile!</h1></center>
      <section>
        <div class="panel">
            <center><h1>Home</h1></center>
            <center><p>My name is John Gerald S. Pizarro, I will become a game developer.</p></center>
        </div>
    </section>
    </Container>
  );
}

export default Home;
